import React from "react";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";
import { useColorMode } from "../context/ColorModeContext";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import { Box } from "@mui/material";

const ToggleSwitch = () => {
  const { toggleColorMode, mode } = useColorMode();
  const theme = useTheme();

  const handleModeChange = (newMode: "light" | "dark") => {
    if (mode !== newMode) {
      toggleColorMode();
    }
  };

  return (
    <Box sx={{ width: "100%", m: 1 }}>
      <Button
        onClick={() => handleModeChange("light")}
        variant={theme.palette.mode === "light" ? "contained" : "outlined"}
        sx={{
          p: 3,
          mr: 1,
          bgcolor: theme.palette.mode === "light" ? "primary.main" : "inherit",
          color: theme.palette.mode === "light" ? "common.white" : "inherit",
        }}
      >
        <LightModeIcon />
      </Button>
      <Button
        onClick={() => handleModeChange("dark")}
        variant={theme.palette.mode === "dark" ? "contained" : "outlined"}
        sx={{
          p: 3,
          bgcolor: theme.palette.mode === "dark" ? "primary.main" : "inherit",
          color: theme.palette.mode === "dark" ? "common.white" : "inherit",
        }}
      >
        <DarkModeIcon />
      </Button>
    </Box>
  );
};

export default ToggleSwitch;
